import { useEffect, useRef, useState } from 'react';
/**
 * hooks that controls the leading and trailing area widths for inputs.
 * Leading is for prefix
 * Trailing is for suffix, icon, buttons (trailing area)
 */

function useLeadingWidth(dependencies) {
  var leadingRef = useRef(null);
  var [leadingWidth, setLeadingWidth] = useState(0);
  useEffect(() => {
    var element = leadingRef.current;
    if (!element) return;
    var updateWidth = () => setLeadingWidth(element.offsetWidth);
    updateWidth();
    var observer = new ResizeObserver(updateWidth);
    observer.observe(element);
    return () => observer.disconnect();
  }, [dependencies]);
  return {
    leadingRef,
    leadingWidth
  };
}
function useTrailingWidth(dependencies) {
  var trailingRef = useRef(null);
  var [trailingWidth, setTrailingWidth] = useState(0);
  useEffect(() => {
    var element = trailingRef.current;
    if (!element) return;
    var updateWidth = () => setTrailingWidth(element.offsetWidth);
    updateWidth();
    var observer = new ResizeObserver(updateWidth);
    observer.observe(element);
    return () => observer.disconnect();
  }, [dependencies]);
  return {
    trailingRef,
    trailingWidth
  };
}
export { useLeadingWidth, useTrailingWidth };